import browserHydrateFunction from './src/utilities/gatsby/browser-hydrate-function';

// in your gatsby-browser.js
export const replaceHydrateFunction = browserHydrateFunction;
